import { clsx } from 'clsx';
import { type FC, type PropsWithChildren, type ReactNode } from 'react';

import { type TViewMode } from '@/packages/redux-state/store/slices/listingLayout/slice';

import { useElementsRefContext } from '../../context/ElementsRefContext';

import styles from './ContentSection.css';

interface ISectionProps {
  viewMode: TViewMode;
  listing: ReactNode;
  map: ReactNode;
  viewModeSwitchers: ReactNode;
}

export const ContentSection: FC<PropsWithChildren<ISectionProps>> = ({ listing, map, viewMode, viewModeSwitchers }) => {
  const { listingRef } = useElementsRefContext();

  return (
    <div
      className={clsx(styles['section'], {
        [styles['section--only-listing']]: viewMode === 'list',
        [styles['section--hybrid']]: viewMode === 'hybrid',
        [styles['section--only-map']]: viewMode === 'map',
      })}
    >
      <section className={styles['listing-section']}>
        <div className={styles['listing']} data-testid="listing.container" ref={listingRef}>
          {listing}
        </div>
        {viewModeSwitchers}
      </section>
      <section className={styles['map-section']}>{map}</section>
    </div>
  );
};
